import { APIPaths } from "@/apis/api-config";

import BaseApi from "../base-api";

export class AuthApi extends BaseApi {
  async postVerificationCodeNew(
    requestBody: APIPaths["/partner-app/auth/verification-code/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/partner-app/auth/verification-code/new"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/partner-app/auth/verification-code/new", requestBody)).data;
  }
  async postVerificationCodeConf(
    requestBody: APIPaths["/partner-app/auth/verification-code/conf"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/partner-app/auth/verification-code/conf"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/partner-app/auth/verification-code/conf", requestBody)).data;
  }
  async postSignupWithEmail(
    requestBody: APIPaths["/partner-app/auth/signup-with-email"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/partner-app/auth/signup-with-email"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/partner-app/auth/signup-with-email", requestBody)).data;
  }
  async postLoginWithEmail(
    requestBody: APIPaths["/partner-app/auth/login-with-email"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/partner-app/auth/login-with-email"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/partner-app/auth/login-with-email", requestBody)).data;
  }
  async postRenewToken(): Promise<
    APIPaths["/partner-app/auth/renew-token"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/partner-app/auth/renew-token")).data;
  }
  async postResetPassword(
    requestBody: APIPaths["/partner-app/auth/reset-password"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/partner-app/auth/reset-password"]["post"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.post("/partner-app/auth/reset-password", requestBody)).data;
  }
}
